const inputStyles = {
    appBar: {
        position: "relative",
        backgroundColor: '#212121'
    },
    menuButton: {
        marginLeft: "auto"
    },
    appTitle: {
        color: '#fff',
    },
    title: {
        fontSize: '20px',
        marginBottom: '32px',
        fontWeight: '700'
    },
    stepLabel: {
        fontSize: '16px',
        marginTop: '16px'
    },
    paper: {
        boxShadow: '0px 1px 4px rgb(0 0 0 / 25%)',
        borderRadius: '8px',
        marginBottom: '24px'
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end",
    },
    button: {
        marginTop: '28px',
        width: '152px',
        height: '52px'
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    actionBtn: {
        marginRight: '24px',
        textTransform: 'none',
        width: '250px'
    },
    formControl: {
        width: '100%'
    },
    mainContent: {
        padding: '32px'
    },
    paperLabel: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '24px',
        color: '#212121',
        padding: '16px 0px 8px 32px',
        borderBottom: '1px solid #DCDEDF'
    },
    paperContent: {
        padding: '16px'
    },
    paymentDiv: {
        display: 'flex',
        alignItems: 'center'
    }

}

export default inputStyles
